export default {
  metadata: {
    version: '1.0.0',
    id: 'content-block-1.0.0',
    name: 'JDSContentBlock'
  },
  hierarchy: {
    'root-container': [
      {
        'inner-container': [
          {
            'caption-container': ['caption-slot']
          },
          'title-jds-text',
          'description-jds-text',
          {
            'children-container': ['children-slot']
          }
        ]
      },
      {
        'button-container': [
          'primary-jds_button',
          'secondary-jds_button',
          'primary-inverted-jds_button'
        ]
      }
    ]
  },
  base: {
    'root-container': {
      'flex-direction': '{c_0}',
      'align-items': '{c_1}',
      'justify-content': '{c_2}',
      width: '{c_3}',
      gap: '{m}'
    },
    'inner-container': {
      'flex-direction': '{c_4}',
      'align-items': '{c_5}',
      'justify-content': '{c_6}'
    },
    'caption-container': {
      'padding-bottom': '{c_8}',
      hidden: false
    },
    'children-container': {
      hidden: false
    },
    'button-container': {
      'flex-direction': '{c_12}',
      gap: '{c_14}'
    },
    'primary-jds_button': {
      kind: 'primary',
      size: 'small',
      hidden: false
    },
    'secondary-jds_button': {
      kind: 'secondary',
      size: 'small'
    },
    'primary-inverted-jds_button': {
      kind: 'primary',
      size: 'small',
      hidden: true
    },
    'title-jds-text': {
      'font-family': '{text_86}',
      color: '{text_20}',
      'font-size': '{text_85}',
      'line-height': '{text_87}',
      'letter-spacing': '{text_88}',
      'font-weight': '{text_89}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-bottom': '{c_9}'
    },
    'description-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-bottom': '{c_10}'
    }
  },
  variant: {
    size: {
      'xtra-xtra-small': {
        'title-jds-text': {
          'font-family': '{text_137}',
          'font-size': '{text_136}',
          'line-height': '{text_138}',
          'letter-spacing': '{text_139}',
          'font-weight': '{text_140}'
        }
      },
      small: {
        'title-jds-text': {
          'font-family': '{text_81}',
          'font-size': '{text_80}',
          'line-height': '{text_82}',
          'letter-spacing': '{text_83}',
          'font-weight': '{text_84}',
          'padding-bottom': '{c_15}'
        },
        'description-jds-text': {
          'font-family': '{text_117}',
          'font-size': '{text_116}',
          'line-height': '{text_118}',
          'letter-spacing': '{text_119}',
          'font-weight': '{text_120}'
        }
      },
      medium: {
        'caption-container': {
          'padding-bottom': '{c_16}'
        },
        'button-container': {
          gap: '{c_18}'
        },
        'primary-jds_button': {
          size: 'medium'
        },
        'secondary-jds_button': {
          size: 'medium'
        },
        'primary-inverted-jds_button': {
          size: 'medium'
        },
        'title-jds-text': {
          'font-family': '{text_76}',
          'font-size': '{text_75}',
          'line-height': '{text_77}',
          'letter-spacing': '{text_78}',
          'font-weight': '{text_79}',
          'padding-bottom': '{c_17}'
        },
        'description-jds-text': {
          'font-family': '{text_117}',
          'font-size': '{text_116}',
          'line-height': '{text_118}',
          'letter-spacing': '{text_119}',
          'font-weight': '{text_120}'
        }
      },
      large: {
        'caption-container': {
          'padding-bottom': '{c_19}'
        },
        'button-container': {
          gap: '{c_22}'
        },
        'primary-jds_button': {
          size: 'large'
        },
        'secondary-jds_button': {
          size: 'large'
        },
        'primary-inverted-jds_button': {
          size: 'large'
        },
        'title-jds-text': {
          'font-family': '{text_71}',
          'font-size': '{text_70}',
          'line-height': '{text_72}',
          'letter-spacing': '{text_73}',
          'font-weight': '{text_74}',
          'padding-bottom': '{c_20}'
        },
        'description-jds-text': {
          'font-family': '{text_102}',
          'font-size': '{text_101}',
          'line-height': '{text_103}',
          'letter-spacing': '{text_104}',
          'font-weight': '{text_105}'
        }
      },
      'xtra-large': {
        'caption-container': {
          'padding-bottom': '{c_23}'
        },
        'button-container': {
          gap: '{c_26}'
        },
        'primary-jds_button': {
          size: 'large'
        },
        'secondary-jds_button': {
          size: 'large'
        },
        'primary-inverted-jds_button': {
          size: 'large'
        },
        'title-jds-text': {
          'font-family': '{text_66}',
          'font-size': '{text_65}',
          'line-height': '{text_67}',
          'letter-spacing': '{text_68}',
          'font-weight': '{text_69}',
          'padding-bottom': '{c_24}'
        },
        'description-jds-text': {
          'font-family': '{text_102}',
          'font-size': '{text_101}',
          'line-height': '{text_103}',
          'letter-spacing': '{text_104}',
          'font-weight': '{text_105}'
        }
      }
    },
    invertCTA: {
      true: {
        'primary-jds_button': {
          hidden: true
        },
        'primary-inverted-jds_button': {
          hidden: false
        }
      }
    },
    ctaWrap: {
      vertical: {
        'button-container': {
          'flex-direction': '{c_27}'
        },
        'primary-jds_button': {
          fullWidth: true
        },
        'secondary-jds_button': {
          fullWidth: true
        },
        'primary-inverted-jds_button': {
          fullWidth: true
        }
      }
    },
    shouldOverrideColor: {
      true: {
        'title-jds-text': {
          color: '{text_62}'
        },
        'description-jds-text': {
          color: '{text_62}'
        }
      }
    },
    singleButton: {
      false: {
        'inner-container': {
          width: '{c_28}'
        },
        'button-container': {
          width: '{c_29}'
        }
      }
    },
    isTertiary: {
      true: {
        'secondary-jds_button': {
          kind: 'tertiary'
        }
      }
    },
    _hasCaptionSlot: {
      false: {
        'caption-container': {
          hidden: true
        }
      }
    },
    _hasChildrenSlot: {
      false: {
        'children-container': {
          hidden: true
        },
        'description-jds-text': {
          'padding-bottom': '{custom_5}'
        }
      }
    },
    _hasDescription: {
      false: {
        'description-jds-text': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      desktop: {
        medium: {
          'title-jds-text': {
            'padding-bottom': '{c_30}'
          }
        },
        large: {
          'title-jds-text': {
            'padding-bottom': '{c_31}'
          }
        },
        'xtra-large': {
          'title-jds-text': {
            'padding-bottom': '{c_32}'
          }
        }
      }
    },
    {
      true: {
        'xtra-xtra-small': {
          'root-container': {
            'flex-direction': '{c_33}',
            'justify-content': '{c_34}',
            'align-items': '{c_35}'
          },
          'button-container': {
            'flex-direction': '{c_36}',
            'justify-content': '{c_37}',
            'align-items': '{c_38}'
          },
          'inner-container': {
            flex: 1
          },
          'primary-jds_button': {
            hidden: false
          },
          'secondary-jds_button': {
            hidden: true
          },
          'primary-inverted-jds_button': {
            hidden: true
          }
        }
      }
    },
    {
      false: {
        false: {
          'title-jds-text': {
            'padding-bottom': '{custom_5}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['_platform', 'size'],
    ['singleButton', 'size'],
    ['_hasChildrenSlot', '_hasDescription']
  ],
  api: {
    config: {
      _platform: {
        values: ['mobile', 'desktop']
      },
      size: {
        values: [
          'xtra-small',
          'xtra-xtra-small',
          'small',
          'medium',
          'large',
          'xtra-large'
        ],
        doc_description: 'It can be used to control the size of ContentBlock.'
      },
      ctaWrap: {
        values: ['horizontal', 'vertical'],
        doc_description:
          'It can be used to either wrap the primary button, secondary button horizontally or vertically.'
      },
      invertCTA: {
        values: [false, true],
        doc_description: 'It inverts the order of the CTAs if true.'
      },
      shouldOverrideColor: {
        values: [false, true]
      },
      singleButton: {
        values: [false, true]
      },
      isTertiary: {
        values: [false, true]
      },
      _hasCaptionSlot: {
        values: [true, false]
      },
      _hasChildrenSlot: {
        values: [true, false]
      },
      _hasDescription: {
        values: [true, false]
      }
    },
    data: {
      'primary-jds_button': {
        label: {
          type: 'string',
          name: 'primaryCTA',
          doc_description: 'It displays label of secondary button of Toast.'
        }
      },
      'secondary-jds_button': {
        label: {
          type: 'string',
          name: 'secondaryCTA',
          doc_description: 'It displays label of primary button of Toast.'
        }
      },
      'primary-inverted-jds_button': {
        label: {
          type: 'string',
          name: 'primaryCTA',
          doc_description: 'It displays label of secondary button of Toast.'
        }
      },
      'title-jds-text': {
        value: {
          type: 'string',
          name: 'title',
          doc_description: 'It displays the title of ContentBlock.'
        }
      },
      'description-jds-text': {
        value: {
          type: 'string',
          name: 'description',
          doc_description:
            'It can be used to add description to the ContentBlock.'
        }
      }
    },
    children: {
      'caption-slot': {
        name: 'caption',
        accepts: ['jds_text', 'jds_badge', 'jds_tag'],
        max: 1,
        doc_description:
          "It displays the header of the ContentBlock. Can be 'badge', 'text', 'tag'."
      },
      'children-slot': {
        name: 'children',
        accepts: ['any'],
        max: 1
      }
    },
    events: {
      'primary-jds_button': {
        onClick: 'onPrimaryClick'
      },
      'secondary-jds_button': {
        onClick: 'onSecondaryClick'
      },
      'primary-inverted-jds_button': {
        onClick: 'onPrimaryClick'
      }
    },
    a11y: {
      'primary-jds_button': {
        properties: {
          ariaLabel: 'primaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'secondary-jds_button': {
        properties: {
          ariaLabel: 'secondaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'primary-inverted-jds_button': {
        properties: {
          ariaLabel: 'primaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
